import * as e from "react";
import a from "../lib/IconBase.es.js";
import c from "../defs/ChatCircle.es.js";
const o = e.forwardRef((r, t) => /* @__PURE__ */ e.createElement(a, { ref: t, ...r, weights: c }));
o.displayName = "ChatCircleIcon";
const s = o;
export {
  s as ChatCircle,
  o as ChatCircleIcon
};
